<div class="notification-banner" [class.mve-active]="showMveWarning" *ngIf="!isLoading && shouldShowBanner">
    <!-- Dynamic Progress Bar -->
    <div *ngIf="showMveWarning" class="mve-progress-bar" [style.width.%]="mveUsagePercent"></div>

    <!-- MVE Usage Warning (80% to 99%) -->
    <p *ngIf="showMveWarning && mveUsagePercent < 100" class="mve-warning">
        <tui-icon icon="@tui.triangle-alert" class="mve-warning-icon"></tui-icon>
        <span>{{ mveUsagePercent }}% of MVE used for this month. </span>
        <button tuiLink type="button"
            [style.text-decoration-line]="'underline'" appearance="link" [textContent]="'Upgrade now'" (click)="navigateToUpgrade()" [style.color]="'var(--tui-text-action)'"></button>
        <span> to avoid reaching your limit.</span>
    </p>

    <!-- MVE Usage Warning (100%+) -->
    <p *ngIf="showMveWarning && mveUsagePercent >= 100" class="mve-warning">
        <tui-icon icon="@tui.triangle-alert" class="mve-warning-icon"></tui-icon>
        <span>{{ mveUsagePercent }}% of MVE used for this month. </span>
        <button tuiLink type="button"
            [style.text-decoration-line]="'underline'" appearance="link" [textContent]="'Upgrade now'" (click)="navigateToUpgrade()" [style.color]="'var(--tui-text-action)'"></button>
        <span> to increase your limit.</span>
    </p>

    <!-- No Active Plan Message -->
    <p *ngIf="!showMveWarning && hasNoActivePlan">
        Hi {{ userName }}. You don't have an active plan. To start using the service, please 
        <button tuiLink type="button"
            [style.text-decoration-line]="'underline'" appearance="link" [textContent]="'choose your plan'" (click)="navigateToPlan()" [style.color]="'var(--tui-text-action)'"></button> now.
    </p>
    
    <!-- Expired Plan Message -->
    <p *ngIf="!showMveWarning && !hasNoActivePlan && isExpired">
        Hi {{ userName }}. Your {{ formattedPlanName ? (formattedPlanName + ' plan') : 'plan' }} has expired. To continue using the service, please 
        <button tuiLink type="button"
            [style.text-decoration-line]="'underline'" appearance="link" [textContent]="'upgrade your plan'" (click)="navigateToPlan()" [style.color]="'var(--tui-text-action)'"></button> now.
    </p>
    
    <!-- Trial Expiring Soon Message -->
    <p *ngIf="!showMveWarning && !hasNoActivePlan && !isExpired">
        Hi {{ userName }}. Your {{ formattedPlanName && formattedPlanName.toLowerCase() !== 'trial' ? (formattedPlanName + ' trial') : 'trial' }} expires in {{ trialDaysRemaining }} {{ trialDaysRemaining === 1 ? 'day' : 'days' }}. To keep enjoying the perks, please 
        <button tuiLink type="button"
            [style.text-decoration-line]="'underline'" appearance="link" [textContent]="'pick your plan'" (click)="navigateToPlan()" [style.color]="'var(--tui-text-action)'"></button> today.
    </p>

</div>  